export default __webpack_public_path__ + "static/media/cases.f899f81f.png";